import { BannerLocaleEnum } from 'domains/merchandising/api'
import { useIsI18nEnabled } from 'domains/merchandising/utils/useIsI18nEnabled.hooks'
import { useRetailerId } from 'utils/routing/params.hooks'

enum RetailerId {
  CostcoCanada = '354',
}

const retailerLocales = {
  [RetailerId.CostcoCanada]: [BannerLocaleEnum.EnCa, BannerLocaleEnum.FrCa],
}

export const useLocales = () => {
  const retailerId = useRetailerId()
  const locales = retailerLocales[retailerId] ?? [BannerLocaleEnum.EnUs]

  const isI18nEnabled = useIsI18nEnabled()
  return isI18nEnabled ? locales : locales.slice(0, 1)
}
